export enum EventedArrayEvent {
  add = 'add',
  remove = 'remove',
}

export class EventedArray {
  public maxValues: number;
  public values: Array<any>;
  private subscribers: any = {
    [EventedArrayEvent.add]: [],
    [EventedArrayEvent.remove]: [],
  };

  constructor (maxValues?: number) {
    this.values = [];
    this.maxValues = maxValues ? maxValues : 0;
  }

  add(value: any) {
    this.values.push(value);
    this.values = this.values.slice(this.maxValues * -1, this.values.length);
    this.fire(EventedArrayEvent.add, value);
  }

  on(event: EventedArrayEvent, callback: Function) {
    this.subscribers[event].push(callback);
  }

  last() {
    return this.values[this.values.length -1];
  }

  fire(event: EventedArrayEvent, value: any) {
    for (const callback of this.subscribers[event]) {
      callback && callback(value);
    }
  }

  getSubscribers() {
    return this.subscribers;
  }
}
